module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-id-1.da311f11.png";